import { isEmpty } from 'lodash';
import MedalliaClient from '../../clients/MedalliaClient';

function transformMedalliaMappingConnectionRequest(medalliaSettings) {
  const formattedBody = {
    mappings: [],
  };
  const tempBody = JSON.stringify(medalliaSettings.body);
  const items = JSON.parse(tempBody);
  Object.keys(items).forEach((it) => {
    const newMap = {
      surveyId: it,
      mapToSkills: items[it],
    };
    formattedBody.mappings.push(newMap);
  });
  return {
    body: formattedBody,
    method: MedalliaClient.HTTP_METHODS.POST,
  };
}

function transformMedalliaSurveySkillsToDBRequest(medalliaSettings) {
  const formattedBody = {
    mappings: [],
  };
  const tempBody = JSON.stringify(medalliaSettings.body);
  const items = JSON.parse(tempBody);
  Object.keys(items).forEach((it) => {
    const newMap = {
      surveyId: it,
      mapToSkills: items[it],
    };
    formattedBody.mappings.push(newMap);
  });
  return {
    body: formattedBody,
    method: MedalliaClient.HTTP_METHODS.POST,
  };
}

function transformMedalliaMappingConnectionResponse(response) {
  let medalliaMappingResult = null;
  if (!isEmpty(response)) {
    medalliaMappingResult = response.status;
  }
  return medalliaMappingResult;
}

function transformMedalliaSurveySkillsToDBResponse(response) {
  const medalliaMappingResult = {
    status: null,
    data: null,
  };
  if (!isEmpty(response)) {
    medalliaMappingResult.status = response.status;
    medalliaMappingResult.data = response.data;
  }
  return medalliaMappingResult;
}

function transformMedalliaDelSurveySkillFromDBResponse(response) {
  const medalliaResult = {
    status: null,
    data: null,
  };
  if (!isEmpty(response)) {
    medalliaResult.status = response.status;
    medalliaResult.data = response.data;
  }
  return medalliaResult;
}

function transformMedalliaConfigResponse(response) {
  let medalliaConfigResult = null;
  if (!isEmpty(response)) {
    medalliaConfigResult = response.status;
  }
  return medalliaConfigResult;
}

function transformMedalliaDelSurveySkillFromDBRequest(medalliaSettings) {
  const formattedBody =
    {
      data: {
        mappings: [
          {
            surveyId: medalliaSettings.sId,
            removeFromSkills: medalliaSettings.skId,
          },
        ],
      },
    };
  return {
    body: formattedBody,
    method: MedalliaClient.HTTP_METHODS.DELETE,
  };
}

function transformMedalliaApiConnectionRequest(medalliaSettings) {
  const formattedBody = {
    pageId: medalliaSettings.body[0].info,
    channelId: medalliaSettings.body[1].info,
    baseUrl: medalliaSettings.body[2].info,
    clientId: medalliaSettings.body[3].info,
    clientSecret: medalliaSettings.body[4].info,
  };
  return {
    body: formattedBody,
    method: MedalliaClient.HTTP_METHODS.POST,
  };
}

function transformMedalliaSaveConfigRequest(medalliaSettings) {
  const formattedBody = {
    pageId: medalliaSettings.body[0].info,
    channelId: medalliaSettings.body[1].info,
    baseUrl: medalliaSettings.body[2].info,
    clientId: medalliaSettings.body[3].info,
    clientSecret: medalliaSettings.body[4].info,
    isActive: medalliaSettings.isActive,
    interactivenessOn: medalliaSettings.body[5].info,
    agentMessageCount: Number(medalliaSettings.body[6].info),
    consumerMessageCount: Number(medalliaSettings.body[7].info),
  };
  let selectedMethod = null;
  if (medalliaSettings.lastUpdatedOn) {
    formattedBody.lastUpdatedOn = medalliaSettings.lastUpdatedOn;
    selectedMethod = MedalliaClient.HTTP_METHODS.PATCH;
  } else {
    selectedMethod = MedalliaClient.HTTP_METHODS.POST;
  }
  return {
    body: formattedBody,
    method: selectedMethod,
  };
}

function transformMedalliaInitializationInfoResponse(response) {
  let medalliaIntializationInfo = null;
  if (!isEmpty(response)) {
    medalliaIntializationInfo = response.data;
  }
  return medalliaIntializationInfo;
}

function transformMedalliaAccountInfoResponse(response) {
  let medalliaAccountInfo = null;
  if (!isEmpty(response)) {
    medalliaAccountInfo = response.data;
  }
  return medalliaAccountInfo;
}

function transformMedalliaAllSurveyResponse(response) {
  this.medalliaAllSurvey = [];
  if (!isEmpty(response)) {
    response.data.surveys.forEach((su) => {
      const surveyObj = {
        id: su.surveyId,
        value: su.surveyTitle,
        mappedToSkills: su.mappedToSkills,
      };
      this.medalliaAllSurvey.push(surveyObj);
    });
  }
  return this.medalliaAllSurvey;
}

function transformMedalliaAllSkillResponse(response) {
  this.medalliaAllSkill = [];
  if (!isEmpty(response)) {
    response.data.forEach((sk) => {
      const skillObj = {
        id: sk.skillId,
        value: sk.skillName,
        hasPcs: sk.hasPcs || false,
      };
      this.medalliaAllSkill.push(skillObj);
    });
  }
  return this.medalliaAllSkill;
}

function transformMedalliaTestAPIConfigResponse(response) {
  let medalliaTestAPIConfigResult = null;
  if (!isEmpty(response)) {
    medalliaTestAPIConfigResult = response.status;
  }
  return medalliaTestAPIConfigResult;
}


export default {
  transformMedalliaInitializationInfoResponse,
  transformMedalliaAllSurveyResponse,
  transformMedalliaAllSkillResponse,
  transformMedalliaTestAPIConfigResponse,
  transformMedalliaApiConnectionRequest,
  transformMedalliaMappingConnectionRequest,
  transformMedalliaMappingConnectionResponse,
  transformMedalliaSaveConfigRequest,
  transformMedalliaAccountInfoResponse,
  transformMedalliaConfigResponse,
  transformMedalliaSurveySkillsToDBRequest,
  transformMedalliaSurveySkillsToDBResponse,
  transformMedalliaDelSurveySkillFromDBRequest,
  transformMedalliaDelSurveySkillFromDBResponse,
};
